import React from 'react';
import CategoryService from '../../../services/CategoryService';
import { faThLarge } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';

const Category = () => {

  // Definir columnas - estructura APLANADA (ultra-simple)
  const columns = [
    {
      key: 'categoryName',
      label: 'category.categoryName',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'text',
      placeholder: 'category.categoryNamePlaceholder', 
      required: true,
      icon: 'fa-align-left',
      // Filtro:
      showInFilter: true,
      filterSize: 'large'
    },
    {
      key: 'enabled',
      label: 'category.enabled',
      showInGrid: false,  // No en grid (tiene toggle)
      sortable: false,
      // Solo filtro:
      showInFilter: true,
      filterType: 'checkbox',
      filterSize: 'small'
    }
  ];

  return (
    <CrudManager
      service={CategoryService}
      columns={columns}
      entityName="category"
      icon={faThLarge}
      formLayout="modal"
    />
  );
};

export default Category;

